import { defineStore } from 'pinia';

export const useRouterStateStore = defineStore('routerState', {
  state: () => ({
    lastRoute: '',
  }),
  actions: {
    setLastRoute(route:any) {
      this.lastRoute = route;
    },
  },
  getters:{
    getRoute: (state) => state.lastRoute,
  },
  persist: true,  // Enable persistence
});
